import { navigate } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { Button } from 'nzk-react-components'
import React from 'react'
import styled from "styled-components"
import useModal from '../../hooks/useModal'
import { PlansSelectorPrice } from './PlansSelector'

type Props = {
  monthly: PlansSelectorPrice
  quarterly: PlansSelectorPrice
}

const Wrapper = styled.div`
background: #ffffff;
border: 2px solid #FF4822;
padding: 20px 20px;
border-radius: 14px;

.logo {
  display: flex;
  justify-content: center;
  width: 100%;
  /* margin-top: -80px; */
  margin-bottom: 20px;
}

h2 {
  margin: 0;
  margin-bottom: 0.8em;
  color: #FF4822;
  font-weight: bold;
  text-align: center;
  font-size: 2rem;
}

.price-difference, .number-children, .plan-name {
  font-weight: bold;
  font-size: 1.2em;
  color: #FF4822;
}

.save {
  font-size: 1em;
  display: flex;
  flex-direction: column;
  gap: 0.4em;
  justify-content: center;
  align-items: center;


  > div {
    display: flex;
    gap: 0.3em;
    align-items: flex-end;
  }

  &.from { }
  &.up-to { }


}

.actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2em;
  gap: 0.4em;
}

`

export const QuarterlyUpsellModal = (props: Props) => {
  if (!props.monthly || !props.quarterly) return null

  const p1c_1 = (props.monthly?.tiers[0]?.flat_amount || 0) * 3
  const p1c_2 = props.quarterly?.tiers[0]?.flat_amount || 0
  const percentSave = 1 - p1c_2 / p1c_1

  return <Wrapper>
    <div className='logo'>
      <StaticImage
        src="../../images/will-logo2xl.png"
        alt="Night Zookeeper"
        height={180}
        placeholder="blurred"
      />
    </div>
    {/* <h2>Don't miss out!</h2> */}
    <h2>Save {Math.floor(percentSave * 100)}% with<br />the 3 Month Plan</h2>
    <div className='save from' style={{
      marginBottom: '20px'
    }}>
      <div>Same flexibility. Cancel anytime.</div>
    </div>

    <div className='actions'>
      <Button theme='confirm' size='small' onClick={() => {
        navigate(`/parents/checkout/${props.quarterly.id}`)
      }}>Get 3 Month Offer</Button>
      <Button
        // theme='primary'
        backgroundColor='#3eb6f2'
        color='#fff'
        size='small'
        onClick={() => {
          navigate(`/parents/checkout/${props.monthly.id}`)
        }}
      >Continue with Monthly</Button>
    </div>
  </Wrapper>
}

export const useQuarterlyUpsellModal = () => {
  // @ts-ignore
  const m = useModal(<QuarterlyUpsellModal />, () => { })

  const open = (props: Props & {
    forced?: boolean
  }) => {
    if (!props.forced && sessionStorage.getItem('monthly-offer')) {
      navigate(`/parents/checkout/${props.monthly.id}`)
      return
    }
    sessionStorage.setItem('monthly-offer', 'true')
    m.open(props)
  }

  return {
    open,
    dismiss: m.dismiss,
    Modal: m.Modal,
  }
} 
